import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FoljaForma, FoljaMenyra, FoljaNumri, FoljaUrdheroreTrajtaTeShkurtraTeRasesDhanore, FoljaVeta } from '@core/enums/folja.enum';
import { FoljaUrdherore } from '@core/globals/folja/folja-urdherore-constants';
import { FoljaConstants } from '@core/globals/folja/folja.constants';
import { FoljaUrdheroreTrajtaTeShkurtraDhanoreForCreationDTO } from '@core/interfaces/dto/folja-urdherore-trajta-te-shkurtra-dhanore-for-creation-dto.interface';
import { FoljaBaza } from '@core/interfaces/models/folja-baza.interface';
import { FoljaUrdheroreTrajtaTeShkurtraDhanoreFormulaService } from './folja-urdherore-trajta-te-shkurtra-dhanore-formula.service';

@Injectable({
  providedIn: 'root',
})
export class FoljaUrdheroreTrajtaTeShkurtraDhanoreService {
  constructor(private foljaUrdheroreTrajtaTeShkurtraDhanoreFormulaService: FoljaUrdheroreTrajtaTeShkurtraDhanoreFormulaService, private fb: UntypedFormBuilder) { }

  insertForms(foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    let formArrays = ['foljaBaza.foljaUrdheroreTrajtaTeShkurtraDhanoreInitial', 'foljaBaza.foljaUrdheroreTrajtaTeShkurtraDhanore'];
    for (let i = 0; i < formArrays.length; i++) {
      const formArray = form.get(formArrays[i]) as UntypedFormArray;
      this.generateUrdheroreForms(formArray);
      foljaBaza.foljaUrdheroreTrajtaTeShkurtraDhanore?.forEach((item) => {
        let index = formArray.controls.findIndex(
          (c) =>
            c.get('numriId')?.value == item.numriId &&
            c.get('formaId')?.value == item.formaId &&
            // c.get('vetaId')?.value == item.vetaId &&
            c.get('trajtaTeShkurtraDhanoreId')?.value == item.trajtaTeShkurtraDhanoreId &&
            c.get('pershkrimi')?.value == '' &&
            c.get('renditja')?.value == item.renditja
        );
        if (index != -1) {
          formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
        } else {
          this.addNewLakimi(formArray, item.formaId, item.numriId, item.trajtaTeShkurtraDhanoreId, item.pershkrimi, item.renditja);
        }
      });
    }
  }

  generateForms(formArray: UntypedFormArray) {
    this.generateUrdheroreForms(formArray);
  }

  generateFormula(baza: string, foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    this.foljaUrdheroreTrajtaTeShkurtraDhanoreFormulaService.generateFormula(
      baza,
      foljaBaza,
      form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraDhanore') as UntypedFormArray
    );
  }

  private generateUrdheroreForms(formArray: UntypedFormArray) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }
    for (const ff of FoljaConstants.FoljaForma) {
      for (const fttshdh of FoljaUrdherore.FoljaUrdheroreTrajtaTeShkurtraDhanore) {
        for (const fn of FoljaUrdherore.FoljaNumri) {
          const foljaForm = this.fb.group({
            formaId: ff.id,
            numriId: fn.id,
            vetaId: FoljaVeta.Edyte,
            trajtaTeShkurtraDhanoreId: fttshdh.id,
            pershkrimi: '',
            renditja: 1
          });

          formArray.push(foljaForm);
        }
      }
    }
  }

  addNewLakimi(formArray: UntypedFormArray, forma: FoljaForma, numri: FoljaNumri, ttshdh: FoljaUrdheroreTrajtaTeShkurtraTeRasesDhanore, pershkrimi?: string, renditja?: number) {
    const renditjet = formArray.value.filter((c: any) => c.numriId == numri && c.trajtaTeShkurtraDhanoreId == ttshdh).map((c: any) => c.renditja);
    const prevIndex = Math.max(...(renditjet.length > 0 ? renditjet : [0]));
    const foljaForm = this.fb.group({
      formaId: forma,
      numriId: numri,
      vetaId: FoljaVeta.Edyte,
      trajtaTeShkurtraDhanoreId: ttshdh,
      pershkrimi: pershkrimi,
      renditja: renditja ?? prevIndex + 1
    });
    formArray.push(foljaForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: FoljaUrdheroreTrajtaTeShkurtraDhanoreForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraDhanore') as UntypedFormArray;

    const veproreParam = form.get('foljaBaza.veproreParam')?.value;
    const joveproreParam = form.get('foljaBaza.joveproreParam')?.value;

    let formArrayValue = formArray.getRawValue();

    if (!veproreParam) {
      formArrayValue = formArrayValue.filter((e: any) => e.formaId != FoljaForma.Veprore);
    }
    if (!joveproreParam) {
      formArrayValue = formArrayValue.filter((e: any) => e.formaId != FoljaForma.JoVeprore);
    }

    formArrayValue.forEach((e: any) => {
      creationDTO.push({
        numriId: e.numriId,
        formaId: e.formaId,
        vetaId: e.vetaId,
        trajtaTeShkurtraDhanoreId: e.trajtaTeShkurtraDhanoreId,
        pershkrimi: e.pershkrimi,
        renditja: e.renditja
      });
    });

    return creationDTO;
  }

  getErrors(foljaForm: UntypedFormGroup) {
    let errors: { menyraId: number; formaId: number; vetaId?: number; numriId?: number; trajtaTeShkurtraDhanoreId?: number, pershkrimi: string }[] = [];
    let initial = foljaForm.getRawValue().foljaUrdheroreTrajtaTeShkurtraDhanoreInitial;
    let formula = foljaForm.getRawValue().foljaUrdheroreTrajtaTeShkurtraDhanore;

    for (const ff of FoljaConstants.FoljaForma) {
      for (const fttshdh of FoljaUrdherore.FoljaUrdheroreTrajtaTeShkurtraDhanore) {
        for (const fn of FoljaUrdherore.FoljaNumri) {

          const fmap = formula
            .filter((a: any) => a.formaId == ff.id && a.numriId == fn.id && a.trajtaTeShkurtraDhanoreId == fttshdh.id)
            .map((a: any) => a.pershkrimi)
            .join(', ');

          const imap = initial
            .filter((a: any) => a.formaId == ff.id && a.numriId == fn.id && a.trajtaTeShkurtraDhanoreId == fttshdh.id)
            .map((a: any) => a.pershkrimi)
            .join(', ');

          if (fmap != imap) {
            errors.push({
              menyraId: FoljaMenyra.Urdherore,
              formaId: ff.id,
              numriId: fn.id,
              trajtaTeShkurtraDhanoreId: fttshdh.id,
              pershkrimi: imap
            });
          }
        }
      }
    }

    return errors;
  }
}
